<template>
	<section class="small-12 columns steps flex" v-if="user">
		<div class="small-12 stepsContainer">
			<div class="small-12 container animated fadeIn" v-if="current_step == 1">
				<div class="small-12 columns formTitle flex justify-center">
					<h2 class="small-12 large-6 text-center">
						Start by selecting the <b>type of company</b> you wish to add.
					</h2>
				</div>
				<div class="small-12 columns form flex justify-center">
					<fieldset class="flex small-12 large-6 companyType">
						<ul class="small-12 flex">
							<li class="small-12 columns" v-if="company_options">
								<label class="small-12">Business Type<em class="cRed">*</em></label>
								<div class="small-12 columns selectContainer borderRadius8">
									<select class="small-12 columns" name="company_type" v-model="new_company.type">
			                			<option :value="null" selected disabled>Please Choose...</option>
										<option :value="type.value" v-for="(type, typeIndex) in company_options.company_types" :key="typeIndex" :selected="new_company.type == type.value ? true : false">{{type.title}}</option>
			                		</select>
								</div>
							</li>
						</ul>
					</fieldset>
				</div>
			</div>
			<div class="small-12 container animated fadeIn flex justify-center" v-if="current_step == 2">
				<div class="small-12 columns formTitle flex justify-center">
					<h2 class="small-12 large-6 text-center">
						Now, we need your <b>company's name</b>.
					</h2>
				</div>
				<div class="small-12 large-6 columns form">
					<fieldset class="flex small-12 address">
						<ul class="small-12 flex">
							<li class="small-12 columns">
								<label class="small-12">Legal Name<em class="cRed">*</em></label>
								<input type="text" name="street_1" v-model="new_company.attributes.name.legal">
							</li>
							<li class="small-12 columns">
								<label class="small-12">Doing Business As (If Different)</label>
								<input type="text" name="street_2" v-model="new_company.attributes.name.dba">
							</li>
						</ul>
					</fieldset>
				</div>
			</div>
			<div class="small-12 container animated fadeIn flex justify-center" v-if="current_step == 3">
				<div class="small-12 columns formTitle flex justify-center">
					<h2 class="small-12 large-6 text-center">
						Enter your <b>company's address</b> and <b>phone number</b>.
					</h2>
				</div>
				<div class="small-12 large-6 columns form">
					<fieldset class="flex small-12 address">
						<ul class="small-12 flex">
							<li class="small-12 columns">
								<label class="small-12">Street<em class="cRed">*</em></label>
								<input type="text" name="street_1" v-model="new_company.attributes.address.street_1">
							</li>
							<li class="small-12 columns">
								<input type="text" name="street_2" v-model="new_company.attributes.address.street_2">
							</li>
							<li class="small-12 columns">
								<label class="small-12">City<em class="cRed">*</em></label>
								<input type="text" name="city" v-model="new_company.attributes.address.city">
							</li>
							<li class="small-12 columns">
								<label class="small-12">State<em class="cRed">*</em></label>
								<div class="small-12 columns selectContainer borderRadius8" v-if="states">
									<select class="small-12 columns" name="state" v-model="new_company.attributes.address.state">
			                			<option :value="null" selected disabled>Please Choose...</option>
										<option :value="state.abbreviation" v-for="(state, stateIndex) in states.options" :key="stateIndex" :selected="new_company.attributes.address.state == state.abbreviation ? true : false">{{state.title}}</option>
			                		</select>
								</div>
							</li>
							<li class="small-12 columns">
								<label class="small-12">Zip Code<em class="cRed">*</em></label>
								<input type="text" name="zip_code" v-model="new_company.attributes.address.zip_code">
							</li>
							<li class="small-12 columns">
								<label class="small-12">Phone</label>
								<input type="tel" name="phone" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" placeholder="" v-model="new_company.attributes.phone_number" @input="formatNumber">
							</li>
						</ul>
					</fieldset>
				</div>
			</div>
			<div class="small-12 container animated fadeIn flex justify-center" v-if="current_step == 4">
				<div class="small-12 columns formTitle flex justify-center">
					<h2 class="small-12 large-6 text-center">
						And finally...
					</h2>
				</div>
				<div class="small-12 large-6 columns form">
					<fieldset class="flex small-12 address">
						<ul class="small-12 flex">
							<li class="small-12 columns flex vertical-align justify-center">
								<label class="small-12 text-center" style="margin-right:20px; margin-bottom:20px;">Are you an owner of the company?</label>
								<div class="small-12 large-3 toggle-button">
									<toggle-button v-model="new_company.attributes.user.is_owner" color="#18bbf7" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="90" :height="40" :font-size="14"/>
								</div>
							</li>
						</ul>
					</fieldset>
				</div>
			</div>
			<div class="small-12 columns flex justify-center nextStep">
				<a class="backButton auto flex vertical-align justify-center borderRadius4 animated fadeIn" @click="previousStep()" v-if="current_step > 1">
					Previous Step
					<i class="material-icons-outlined flex justify-center vertical-align">arrow_back</i> 
				</a>
				<a class="blueButton auto flex vertical-align justify-center borderRadius4 animated fadeIn" @click="nextStep()" v-if="current_step < total_steps">
					<i class="material-icons-outlined flex justify-center vertical-align">arrow_forward</i> 
					Next Step
				</a>
				<a class="blueButton auto flex vertical-align justify-center borderRadius4 animated fadeIn" @click="createTheCompany()" v-if="current_step == total_steps">
					<i class="material-icons-outlined flex justify-center vertical-align">save</i> 
					Create Company
				</a>
			</div>
		</div>
	</section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, configModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { ConfigRepository } from '@/components/mixins/repositories/config/ConfigRepository'
	import { CompanyRepository } from '@/components/mixins/repositories/companies/CompanyRepository'
	import { UsersRepository } from '@/components/mixins/repositories/users/UsersRepository'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

	// Import the components
	import UserFooter from '@/components/framework/footer/UserFooter.vue'
	import LoadingSpinner from '@/components/framework/helpers/LoadingSpinner.vue'
	import PrimaryNav from '@/components/framework/nav/PrimaryNav.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Steps',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			ConfigRepository,
			CompanyRepository,
			UsersRepository,
			SpinnerMethods

		],

		/*
		**  Set the props
		*/

		props: {

			user: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			total_steps: 4,
			current_step: 1,
			company_options: null,
			states: null

		}),

		/*
		**  Watch em'
		*/

		watch: {

			user: {

				immediate: true, // Load on created
				handler(user) {

					if (user) this.getConfig();

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			getConfig: function() {

				// Get the company types
				this.getCompanyTypes();

				// Get the states
				this.getStates();

			},

			nextStep: function() {

				// Step 1
				if (this.current_step == 1) {

					let validated = this.validateCompanyType();

					if (!validated) {

						this.$swal('Uh Oh!', 'Please select a business type before proceeding to the next step.', 'error');

						return;

					}

				}

				// Step 2
				if (this.current_step == 2) {

					let validated = this.validateName();

					if (!validated) {

						this.$swal('Uh Oh!', 'Please enter in the legal name for your company before proceeding to the next step.', 'error');

						return;

					}

				}

				// Step 3
				if (this.current_step == 3) {

					let validated = this.validateAddress();

					if (!validated) {

						this.$swal('Uh Oh!', 'Please make sure to enter in your complete address before proceeding further.', 'error');

						return;

					}

				}

				// Increment the current step
				if (this.current_step < this.total_steps) this.current_step = this.current_step + 1;

			},

			previousStep: function() {

				// Decrement the current step
				this.current_step = this.current_step - 1;

			},

			formatNumber: function() {

				// Set the var
    			let x = this.new_company.attributes.phone_number.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

    			// Format the phone number
  				this.new_company.attributes.phone_number = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

   			},

			createTheCompany: function() {

				// Show the spinner
				this.showSpinner();

				// Set the slug
				this.slugifyTheSlug();

				// Create the company
				this.createCompany();

			},

			validateCompanyType: function() {

				if (this.new_company.type == null || this.new_company.type.length == 0) return false;

				return true;

			},

			validateName: function() {

				if (this.new_company.attributes.name.legal == null || this.new_company.attributes.name.legal.length == 0) return false;

				return true;

			},

			validateAddress: function() {

				if (this.new_company.attributes.address.street_1 == null || this.new_company.attributes.address.street_1.length == 0) return false;
				if (this.new_company.attributes.address.city == null || this.new_company.attributes.address.city.length == 0) return false;
				if (this.new_company.attributes.address.state == null) return false;
				if (this.new_company.attributes.address.zip_code == null || this.new_company.attributes.address.zip_code.length == 0) return false;

				return true;

			},

			slugifyTheSlug: function() {

				// Set the slug
				this.new_company.attributes.slug = slugify(this.new_company.attributes.name.legal, {
					replacement: '-',
					remove: /[*+~.()'"!:@]/g,
					lower: true,
				});

			},

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>